module.exports = __webpack_public_path__ + "static/movies-35d7ddad80809a5f20d66f7eb01b2f6f.jpg";